import React, { useContext, useEffect, useState } from "react"

import CommonContext from "@src/context"

import Section from "@components/section"
import ClickableImage from "@components/clickableImage"
import Button from "@components/button"
import En from "./sfv_en"
import Zh from "./sfv_zh"

import bgImage from "@images/sfv-bg.jpg"
import matchImg from "@images/season3/sfv-match.png"

const Sfv = () => {
  const [en, setEn] = useState(false)
  const { setBg } = useContext(CommonContext)
  useEffect(() => {
    setBg(bgImage)
  }, [])
  return (
    <div>
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <Button
          color={"blue"}
          onClick={() => {
            setEn(en => !en)
          }}
        >
          {en ? "查看中文版" : "English"}
        </Button>
      </div>
      {en ? <En /> : <Zh />}
      <Section title="对阵表">
        <ClickableImage className="fluidImage" src={matchImg} />
      </Section>
    </div>
  )
}

export default Sfv
